<section class="d-flex">

    <app-menu></app-menu>

  <section id="container" class="container page-container">
    <div
      class="container-content"
      [class.container-content--with-header]="showPlatformHeader"
      [class.container-content--full-page]="hideAppHeader && !showPlatformHeader">
      <app-platform-header *ngIf="showPlatformHeader"></app-platform-header>
      <router-outlet></router-outlet>
    </div>
  </section>
</section>

<ng-container #modalHost></ng-container>

<app-loading-state *ngIf="isLoaderVisible"></app-loading-state>

<b3-toast-region class="app-root-toast-region">
  <b3-toast
    *ngIf="activeToast as toast"
    [open]="toast.open"
    [variant]="toast.variant"
    [label]="toast.label"
    [description]="toast.description || ''"
    auto-dismiss
    (b3-close)="onToastDismiss()">
    <b3-button
      aria-label="Fechar notificação"
      (b3-click)="onToastDismiss()">
      <b3-icon name="close"></b3-icon>
    </b3-button>
  </b3-toast>
</b3-toast-region>
